import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerFlex: {
        flex: 1,
    },
    containerItem: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    checkboxCircle: {
        width: 14,
        height: 14,
        borderRadius: 7,
        borderWidth: 1.5,
        borderColor: theme.colors.colorPrimary,
        marginRight: 8,
    },
    item: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
})

export default styles
